// extracted by mini-css-extract-plugin
export default {"button":"PrimaryButton__button__LA2fP","disabled":"PrimaryButton__disabled___vLbt","outlined":"PrimaryButton__outlined__YlqUG","disabledOutline":"PrimaryButton__disabledOutline__wzTCb","imageSpan":"PrimaryButton__imageSpan__NrIKc","rightImageSpan":"PrimaryButton__rightImageSpan__KaB7f","btnText":"PrimaryButton__btnText__hGhOn"};
    if(module.hot) {
      // 1753447560610
      var cssReload = require("!../../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  